<template>
  <div class="all">
    <div class="banner">
      <img src="../../../assets/webActivity/invite/invite_banner.png" alt="" />
    </div>
    <div class="activity-content">
      <div class="info">
        <img src="../../../assets/webActivity/invite/invite_info.png" alt="" />
        <img
          src="../../../assets/webActivity/invite/invite_shareBtn.png"
          alt=""
          class="share_btn animate__animated animate__pulse"
          id="copy-btn"
          @click="copyShareUrl('#copy-btn')"
        />
        <p>每成功邀请1位好友可获得<span>10元</span>赠送余额</p>
      </div>
      <div class="coin">
        <p>
          <img src="../../../assets/task/task_money_icon.png" alt="" />
          <span>累计收益:{{ state.allCoinnum }}</span>
          <span>待领取收益:{{ state.coinNum }}</span>
        </p>
        <p @click="getCoin">领取</p>
      </div>
      <div class="invite_num">
        <h4>
          已成功邀请<span>{{ state.inviteNums }} </span>位好友
        </h4>
        <ul>
          <li v-for="(item, index) in state.invitedList" :key="index">
            <img :src="item.avatar" alt="" />
            <p>{{ item.user_nicename }}</p>
          </li>
        </ul>
      </div>
      <div class="rule">
        <img
          src="../../../assets/webActivity/invite/invite_rule_title.png"
          alt=""
        />
        <h4>活动时间：{{ state.activeTime }}</h4>
        <p>
          1、邀请者成功邀请1名新用户可获得10元赠送余额，最高可得50元余额,
          <span>获得的收益请当天尽快领取，活动结束后将会清空；</span>
        </p>
        <p>
          2、被邀请者通过邀请链接进行下载注册并登陆App后，完成实名认证后，即为邀请成功。
        </p>
        <p>
          3、0.1折对新用户的界定有严格的判断，若识别为同一名用户重复注册账号，将无法获得奖励（同实名、手机号、设备、符合任意一条均视为同一用户）
        </p>
        <p>
          4、若检测发现邀请者存在利用漏洞获取不当利益的行为，我们将保留回收奖励的权力，并对该行为追加进一步的处罚。
        </p>
        <p>
          5、活动最终解释权归0.1折手游所有，如有疑问请联系客服。
        </p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { nextTick, onMounted, reactive } from "vue";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
import { setToken } from "@/utils/auth.js";
import "animate.css";
import { handleCopy } from "@/utils/tool";
import { getInvite, getInviteReward } from "../../../api/activity";
import { formatDateRange } from "@/utils/date";

const defaulAvatar = require("../../../assets/webActivity/invite/invite_avater.png");

const state = reactive({
  uid: "",
  invitedList: [],
  coinNum: 0,
  allCoinnum: 0,
  shareUrl: "",
  activeTime: "",
});

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
  console.log("onMounted--------");
  nextTick(() => {
    getInviteInfo();
  });
});

// 获取邀请信息
const getInviteInfo = async () => {
  try {
    await getInvite({ uid: state.uid }).then((res) => {
      console.log("邀请信息", res);
      if (res.data.code == 1) {
        state.invitedList = res.data.data.lists;
        state.coinNum = res.data.data.wlqsum;
        state.allCoinnum = res.data.data.allsum;
        state.shareUrl = res.data.data.yqurl;
        state.inviteNums = state.invitedList.length;
        state.activeTime = formatDateRange(res.data.data.time);
      } else {
        state.inviteNums = 0;
        state.activeTime = "12.21 00:00:00-12.22 23:59:59";
      }

      if (state.invitedList.length < 5) {
        // 补全5个
        for (let i = 0; i < 5 - state.inviteNums; i++) {
          state.invitedList.push({
            avatar: defaulAvatar,
            user_nicename: "待邀请",
          });
        }
      }
    });
  } catch (error) {
    if (state.invitedList.length < 5) {
      // 补全5个
      for (let i = 0; i < 5 - state.inviteNums; i++) {
        state.invitedList.push({
          avatar: defaulAvatar,
          user_nicename: "待邀请",
        });
      }
    }
  }
};

// 复制链接按钮
const copyShareUrl = (id) => {
  if (!state.shareUrl) {
    Toast("请重新登陆");
    return;
  }
  handleCopy(id, state.shareUrl);
};

var fetchFlag = false;
const getCoin = async () => {
  if (!state.shareUrl) {
    Toast("请重新登陆");
    return;
  }
  if (fetchFlag) return;
  fetchFlag = true;
  let res = await getInviteReward({ uid: state.uid });
  console.log("领取奖励", res);
  fetchFlag = false;
  if (res.data.code == 1) {
    state.coinNum = 0;
    await getInviteInfo();
  }
  Toast(res.data.msg);
};
</script>
<style scoped>
.all {
  height: 100vh;
  overflow: auto;
  padding-bottom: 150px;
  background: #bcecfa;
}
.activity-content {
  padding: 0 32px;
}
.banner {
  width: 100%;
  height: 616px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.info {
  width: 100%;
  /* height: 626px; */
  border-radius: 60px;
  border: 4px solid #cced85;
  background: #fffcfc;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 32px 0;
  margin-top: -130px;
  position: relative;
  z-index: 2;
}
.info > img {
  width: 638px;
  height: 418px;
}
.info .share_btn {
  width: 606px;
  height: 116px;
  margin-top: -58px;
  animation-iteration-count: infinite;
}
.info p {
  width: 476px;
  height: 50px;
  border-radius: 58px;
  background-color: #f8f5e4;
  color: #cb4c15;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
  margin-top: 24px;
}
.info p span {
  color: #ff6666;
}

/* 已经邀请的好友 */
.invite_num {
  width: 100%;
  border-radius: 60px;
  border: 4px solid #cced85;
  background: #fffcfc;
  margin-top: 32px;
  padding: 32px 24px;
}
.invite_num h4 {
  text-align: center;
  color: #999999;
  font-size: 32px;
}
.invite_num h4 span {
  color: #ff6666;
}
.invite_num ul {
  margin-top: 22px;
  width: 638px;
  height: 202px;
  display: flex;
  align-items: center;
  background-color: #e4f8f6;
  border-radius: 40px;
  padding-left: 20px;
  overflow: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
}
.invite_num ul li {
  flex-shrink: 0;
  margin-right: 20px;
  width: 104px;
}
.invite_num ul li img {
  width: 104px;
  height: 104px;
  border-radius: 20px;
}
.invite_num ul li p {
  font-size: 24px;
  color: #af7164;
  white-space: nowrap;
  width: 104px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

/* 我的收益 */
.coin {
  width: 100%;
  height: 120px;
  border-radius: 40px;
  border: 4px solid #cced85;
  background: #fffcfc;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
}

.coin p:nth-child(1) {
  display: flex;
  align-items: center;
  color: #ff7606;
  font-size: 20px;
  font-weight: 600;
}
.coin p:nth-child(1) img {
  width: 58px;
  height: 58px;
  margin-right: 8px;
}
.coin p:nth-child(1) span:nth-of-type(2) {
  color: #6b6b6b;
  margin-left: 20px;
}
.coin p:nth-child(2) {
  width: 152px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  color: #fff;
  background: linear-gradient(90deg, #ffa45e 0%, #ff5842 100%);
  border-radius: 20px 20px 20px 20px;
  font-size: 36px;
  font-weight: 600;
}
/* 活动规则 */
.rule {
  width: 100%;
  /* height: 846px; */
  border-radius: 60px;
  border: 4px solid #cced85;
  background: #fffcfc;
  margin-top: 60px;
  padding: 0 40px;
  color: #822813;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
}
.rule img {
  width: 322px;
  height: 70px;
  margin-bottom: 24px;
}
.rule h4 {
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
}
.rule p {
  margin-bottom: 40px;
}
.rule p span {
  color: #f66;
}
</style>
